import { useEffect } from "react";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../../../../redux/store";
import {
  ResetEditParticipant,
  initEditParticipant,
} from "../../../../redux/states/editParticipant.state";
import { editParticipantCatalogBridge } from "./editParticipantCatalogBridge";

type UseEditParticipantInitParams = {
  eventId?: string;
  registrationId?: string;
};

export function useEditParticipantInit ({
  eventId,
  registrationId,
}: UseEditParticipantInitParams): void {
  const dispatch = useDispatch<AppDispatch>();
  const isEditMode = !!registrationId;

  useEffect(() => {
    if (!eventId) {
      return;
    }

    dispatch(
      initEditParticipant({
        eventId,
        registrationId,
        isEditMode,
      }),
    );

    return () => {
      editParticipantCatalogBridge.handlers = null;
      dispatch(ResetEditParticipant());
    };
  }, [dispatch, eventId, registrationId, isEditMode]);
}
